module.exports = __webpack_public_path__ + "static/media/3_21.0e59e77a.png";